import { useState, useEffect, useRef, useMemo, useImperativeHandle } from 'react';
import Router from 'next/router';
import { Form, Input, complete } from '@/components';
import { Button, Spin } from 'antd';
import CountdownButton, { ICountdownRef } from './countdownButton';
import { commonApi } from '@/api';
import { useGTagEvent, useRequest } from '@/hooks';
import { getAccessToken, storageHelper } from '@/utils';
import { commonStore } from '@/stores/quick-order';
import Cookies from 'js-cookie';
import { ModalGetCall } from './mode';
import RiskVerification from './mode/ModalRiskVerification';
import validPhone from '@/utils/validPhone';
import { useHideKeyboardOnScroll } from '@/hooks';
import { useText } from './customization';

import styles from './index.module.scss'

import type { FormValue, FormErrors } from '@/components';
import type { FC } from 'react';
import {gtag_event_login, gtag_event_signup} from "@/utils/gTagEvent/gTagEvent";

interface LoginContentProps {
  onFinish?: (data: FormValue | FormErrors) => void;
  onFinishFailed?: (data: FormValue | FormErrors) => void;
  onCancelDrawer?: () => void;
  loginSuccess?:  null | (() => void);
}

const LoginContent: FC<LoginContentProps> = (props, ref) => {

  const scrollRef = useRef(null);
  useHideKeyboardOnScroll(scrollRef);
  const text = useText();

  const form = Form.useForm();
  const { onFinish, onFinishFailed, onCancelDrawer, loginSuccess } = props;
  const { updateState } = commonStore;
  const [accessToken, setAccessToken] = useState(null);
  const [abnormalRegister, setAbnormalRegister] = useState(true)
  const [showCall, setShowCall] = useState<boolean>(false)
  /** 语音验证码确认 */
  const [modalWithReceiveShow, setModalWithReceiveShow] = useState<boolean>(false)
  /** 图形验证码 */
  const [showRiskVerification, setShowRiskVerification] = useState<boolean>(false)
  const [certificate, setCertificate] = useState<string | null>(null)
  const [sendType, setSendType] = useState<'VOICE' | 'SMS' | null>(null)

  const countDownRef = useRef<ICountdownRef>(null)

  const reqLogin = useRequest({ method: 'post', url: commonApi.login, isTips: [93108] });
  const riskVerification = useRequest({ url: commonApi.riskVerification, method: 'post' })

  const __country = '+1';

  useEffect(() => {
    setAccessToken(getAccessToken());
  }, [])

  const onLoginSuccess = () => {
    if (typeof loginSuccess === 'function') {
      loginSuccess();
      return;
    }
  
    if (loginSuccess === null) {
      return;
    }
    
    let baseOrderPath = '/order'; 
    let basePath = '/';

    if (window.__WEB_SITE_APP_CONFIG?.appConfig?.isPebllaDomain && window.__WEB_SITE_APP_CONFIG?.appConfig?.stylePath) {
      baseOrderPath = `/${window.__WEB_SITE_APP_CONFIG?.appConfig?.stylePath}/order`;
      basePath = `/${window.__WEB_SITE_APP_CONFIG?.appConfig?.stylePath}`;
    }

    if (Router.asPath !== baseOrderPath && Router.asPath !== basePath) {
      Router.reload();
    }
    
  }
  // 取消登录 清除验证码
  const handleCancelLogin = async () => {
    form.setFieldsValue({
      code: ''
    })
    form.removeFieldErrors('code')
  }

  const handleLogin = async () => {
    try {
      let headers = {};
      const data = await form.validateFields();
      if (data.code && accessToken) {
        headers = { Accesstoken: accessToken };
      }
      let loginRes = null
      const aiPhoneConfig = sessionStorage.getItem(`__data_buried`)
      let sourceId, sourceFromType;
      if (aiPhoneConfig) {
        const aiPhoneArg = JSON.parse(aiPhoneConfig)
        sourceId = aiPhoneArg?.sourceId
      }
      const isNewRegister = !abnormalRegister;
      loginRes = await reqLogin.send({
        ...data,
        country: __country,
        sourceId,
        ...(isNewRegister && { tag: [{ tagKey: 'Ordering-Website', tagValue: 'Custom-Home-Page' }] }),
      }, { headers });
      // 登录失败的提示
      if (loginRes.status?.code) {
        form.setFieldsError({ code: [{ message: loginRes.status?.msg }] });
        return;
      }
      const sessionId = loginRes.data?.sessionId;
      const member: any = loginRes?.data?.member;
      // 检测是否完成注册
      const res = await detectComplete(member, sessionId);
      if (res === 'cancel') {
        onFinishFailed?.({})
        countDownRef.current?.restartTime?.()
        return handleCancelLogin()
      }

      onCancelDrawer?.()
      const authCode = loginRes?.data?.authCode;

      if (authCode) {
        member.authCode = authCode;
      }

      if (sessionId) {
        const path = window.__WEB_SITE_APP_CONFIG?.appConfig?.isPebllaDomain ? `/${window.__WEB_SITE_APP_CONFIG?.appConfig?.stylePath}` : '/';
        Cookies.set('__session_id', sessionId, { expires: 90, path: path });
      }

      if (abnormalRegister) {
        gtag_event_login()
      } else {
        gtag_event_signup()
      }
      const isLogin = sessionId && member;
      
      updateState({ isLogin, showExpiredTip: loginRes?.data?.meta?.validMonths });
      onFinish?.(loginRes);
      onLoginSuccess();
    }
    catch (ex) {
      onFinishFailed?.(ex || {});
    }
  }

  const synchronizationMember = (member: Record<string, any>) => {
    if (member) {
      updateState({ memberInfo: member });
      storageHelper.setItem('__member_info', member);
    }
  }

  const detectComplete = async (member: Record<string, any>, sessionId: string) => {
    synchronizationMember(member);
    if (!member?.lastName || !member?.firstName) {
      const res = await complete(sessionId);
      console.log(res, 'res111');
      
      if (res === 'cancel') {
        handleCancelLogin()
        return 'cancel'
      }
      return 'complete'
    }
  }

  const getCertificate = (certificate: string | null) => {
    setCertificate(certificate);
  }

  const handleClickReceive = async () => {
    setSendType('VOICE')
    const { phone } = await form.validateFields(['phone'])
    if (phone) {
      await riskVerification.send({ phone, country: __country, sendModeType: 'VOICE' }, { headers: { AccessToken: getAccessToken() } })
        .then((res) => {
          if (res.data?.riskStatus) {
            setModalWithReceiveShow(true)
          } else {
            setShowRiskVerification(true)
          }
        })
    }
  }

  const handleCountdownCallback = (codeRes: Record<string, any>) => {
    if (!codeRes) {
      return false;
    }
    // if (codeRes?.data?.registered) {
    //   setAbnormalRegister(false)
    // }
    setAbnormalRegister(codeRes?.data?.registered)
    return true;
  }

  const handleClickRiskCancel = () => {
    setShowRiskVerification(false)
    countDownRef.current?.restartTime?.()
  }
  const handleClickTerms = () => {
    window.open('https://www.peblla.com/terms-of-service')
  }
  const handleClickPrivacy = () => {
    window.open('https://www.peblla.com/privacy-policy')
  }

  const receiveCodeStyle = useMemo(() => {
    return showCall ? {
      height: '20px',
      marginTop: '28px',
      marginBottom: '14px',
    } : {
      height: 0,
      marginTop: 0,
      marginBottom: 0,
    }
  }, [showCall])

  useEffect(() => {
    if (countDownRef.current && certificate && sendType === 'SMS') {
      countDownRef.current.handleCountdown?.(true)
    }
    if (countDownRef.current && certificate && sendType === 'VOICE') {
      setModalWithReceiveShow(true)
    }
  }, [certificate])

  return (
    <div ref={scrollRef} style={{ height: '100%' }} data-peblla-part="body">
      <Form form={form} className='login_content'>
        <Form.Item
          name='phone'
          requiredMark
          label={text.phoneLabel ?? 'Phone Number'}
          labelProps={{ shrink: true }}
          rules={
            [
              { required: true, message: text.phoneRequired ?? 'Required' },
              { min: '10', max: '10', message: text.phoneInvalid ?? 'Invalid phone number' },
              {
                pattern: (value: string) => {
                  return !validPhone(value, __country)
                }, message: text.phoneInvalid ?? 'Invalid phone number'
              }
            ]
          }>
          <Input
            type='tel'
            rootClassName={styles.phone_input}
            data-peblla-part="phone-input"
            onChange={() => { setShowCall(false); countDownRef.current?.restartTime?.() }}
            prefix={<span data-peblla-part="phone-prefix">{__country}</span>}
          />
        </Form.Item>
        <Form.Item
          name='code'
          requiredMark
          labelProps={{ shrink: true }}
          className={styles.code_input_item}
          label={text.codeLabel ?? 'Validation Code'}
          rules={
            [
              { required: true, message: text.codeRequired ?? 'Required' },
              { max: '6', message: text.codeInvalid ?? 'Invalid validation Code' },
              { pattern: /^\d+$/, message: text.codeInvalid ?? 'Invalid validation Code' }
            ]
          }
          >
          <Input
            type='tel'
            placeholder={text.codePlaceholder ?? 'Validation Code'}
            rootClassName={styles.code_input}
            data-peblla-part="code-input"
            suffix={
              <CountdownButton
                form={form}
                ref={countDownRef}
                arrival={(boo?: boolean) => setShowCall(!!boo)}
                countdownCallback={handleCountdownCallback}
                accessToken={accessToken}
                otherParams={{ country: __country, certificate }}
                unPassed={() => setShowRiskVerification(true)}
                getCertificate={getCertificate}
                onChangeType={() => setSendType('SMS')}
                errorMessage={(str: string) => {
                  form.setFieldsError({ phone: [{ message: str }] });
                }}
              />} />
        </Form.Item>
        {/* 语音验证 */}
        <Form.Item name='receive_code_item' className={`${styles.receive_code_item}`}>
          <div className={styles.receive_code} style={receiveCodeStyle} data-peblla-part="voice-prompt">
            <span>{text.voicePromptText ?? "Didn't receive a code?"}</span>
            &nbsp;
            <Spin spinning={riskVerification.loading} rootClassName={styles.receive_btn}>
              <span
                className={styles.receive_btn}
                onClick={handleClickReceive}
                data-peblla-part="voice-cta"
              >
                {' '}
                {text.voiceCtaText ?? 'Try get a call.'}
              </span>
            </Spin>
          </div>
        </Form.Item>
        {/* 登录注册 */}
        <Form.Item>
          <Button
            type='primary'
            className={styles.login_btn}
            style={{ width: '100%', height: 42 }}
            loading={reqLogin.loading}
            onClick={handleLogin}
            data-peblla-part="submit-btn"
          >
            {text.submitText ?? 'Continue'}
          </Button>
        </Form.Item>
        {text.agreementHTML !== undefined ? (
          <div
            className={styles.login_agreement}
            data-peblla-part="agreement"
            dangerouslySetInnerHTML={{ __html: text.agreementHTML }}
          />
        ) : (
          <div className={styles.login_agreement} data-peblla-part="agreement">
            By providing your phone number, you agree to join the rewards program and accept our{' '}
            <span className={styles.login_agreement_link} onClick={handleClickTerms}>{"Platform's"} Terms</span>
            {' '}and{' '}
            <span className={styles.login_agreement_link} onClick={handleClickPrivacy}>Privacy Policy</span>.
          </div>
        )}
      </Form>

      {/* 语音弹窗 */}
      <ModalGetCall
        restartTime={countDownRef.current?.restartTime}
        startCountdown={countDownRef.current?.startCountdown}
        certificate={certificate}
        open={modalWithReceiveShow}
        onCancel={setModalWithReceiveShow}
        form={form}
        country={__country}
      />

      {/* 图形验证 */}
      {
        showRiskVerification &&
        <RiskVerification
          startCountdown={countDownRef.current?.startCountdown}
          isOpen={showRiskVerification}
          getCertificate={getCertificate}
          onCancel={handleClickRiskCancel}
          sendType={sendType}
        />
      }
    </div>
  )
}

export default LoginContent
